import { DotLottieReact } from '@lottiefiles/dotlottie-react';
import React, { useEffect, useRef } from 'react';
import { useAuth } from '../provider/useAuth';
import { useNavigate } from 'react-router-dom';

const NotFoundPage = ({ onGoBack }) => {
  const containerRef = useRef(null);
  const shapesRef = useRef([]);
  const { logout,isAuthenticated } = useAuth()
  const navigate = useNavigate();

  useEffect(()=>{
    const role = sessionStorage.getItem("role");
    const dashboardPath =
    role === "Institute"
      ? "/institute-dashboard"
      : role === "Teacher"
      ? "/teacher-dashboard"
      : "/dashboard";

    // const dashboardPath = role === 'Institute' ? '/institute-dashboard' : '/dashboard';
    if(role && isAuthenticated){
      navigate(dashboardPath)
    }
  },[])

  useEffect(() => {
    const handleMouseMove = (e) => {
      const x = e.clientX / window.innerWidth;
      const y = e.clientY / window.innerHeight;
      
      shapesRef.current.forEach((shape, index) => {
        if (shape) {
          const speed = (index + 1) * 0.5;
          const xPos = (x * speed * 50) - 25;
          const yPos = (y * speed * 50) - 25;
          
          shape.style.transform = `translate(${xPos}px, ${yPos}px) rotate(${index * 45}deg)`;
        }
      });
    };

    document.addEventListener('mousemove', handleMouseMove);
    return () => document.removeEventListener('mousemove', handleMouseMove);
  }, []);

  const handleGoBack = () => {
    window.history.back()
  };

  const handleGoLogin = () => {
    logout()
    navigate('/login', { replace: true });
  };

  return (
    <div 
      className="min-vh-100 d-flex align-items-center justify-content-center position-relative overflow-hidden"
      style={{
        background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
      }}
    >
      <div className="position-absolute w-100 h-100 overflow-hidden" style={{ zIndex: 1 }}>
        {[...Array(10)].map((_, i) => (
          <div
            key={i}
            className="position-absolute rounded-circle"
            style={{
              background: 'rgba(255, 255, 255, 0.1)',
              left: `${[10, 20, 25, 40, 70, 80, 32, 55, 25, 90][i]}%`,
              width: `${[80, 20, 60, 120, 11, 40, 160, 20, 10, 160][i]}px`,
              height: `${[80, 20, 60, 120, 11, 40, 160, 20, 10, 160][i]}px`,
              animationDelay: `${[0, 2, 4, 0, 3, 5, 7, 15, 2, 11][i]}s`,
              animation: 'float 6s ease-in-out infinite'
            }}
          />
        ))}
      </div>

      <div className="position-absolute w-100 h-100" style={{ zIndex: 2 }}>
        <div
          ref={el => shapesRef.current[0] = el}
          className="position-absolute"
          style={{
            top: '10%',
            left: '10%',
            width: '60px',
            height: '60px',
            background: '#ff6b6b',
            clipPath: 'polygon(50% 0%, 0% 100%, 100% 100%)',
            opacity: 0.15,
            animation: 'rotate 20s linear infinite'
          }}
        />
        <div
          ref={el => shapesRef.current[1] = el}
          className="position-absolute rounded-circle"
          style={{
            top: '20%',
            right: '10%',
            width: '40px',
            height: '40px',
            background: '#4ecdc4',
            opacity: 0.15,
            animation: 'rotate 15s linear infinite reverse'
          }}
        />
        <div
          ref={el => shapesRef.current[2] = el}
          className="position-absolute"
          style={{
            bottom: '30%',
            left: '15%',
            width: '50px',
            height: '50px',
            background: '#45b7d1',
            clipPath: 'polygon(25% 0%, 100% 0%, 75% 100%, 0% 100%)',
            opacity: 0.15,
            animation: 'rotate 25s linear infinite'
          }}
        />
      </div>

      <div className="container-fluid px-3" style={{ zIndex: 10 }}>
        <div className="row justify-content-center">
          <div className="col-12 col-md-10 col-lg-8 col-xl-8">
            <div className="text-center text-white" ref={containerRef}>
                <DotLottieReact
                    src="https://lottie.host/cb51fee7-d914-467f-82e5-0b1a82e5e562/dUp8njHfL0.lottie"
                    loop
                    autoplay
                />
              <p 
                className="lead fs-5 mb-2"
                style={{ 
                  animation: 'fadeInUp 0.8s ease 0.6s both',
                  opacity: 0.9,
                  lineHeight: 1.6,
                  maxWidth: '500px',
                  margin: '0 auto 3rem'
                }}
              >
                Oops! The page you're looking for seems to have wandered off. 
                Don't worry, it happens to the best of us. Let's get you back on track.
              </p>
              <div 
                className="d-flex flex-column flex-sm-row gap-3 justify-content-center align-items-center"
                style={{ animation: 'fadeInUp 0.8s ease 0.8s both' }}
              >
                <button
                  onClick={handleGoBack}
                  className="btn btn-lg px-4 py-3 fw-semibold d-flex align-items-center gap-2 border-0 custom-btn"
                  style={{
                    background: 'linear-gradient(45deg, #4ecdc4, #44a08d)',
                    color: 'white',
                    boxShadow: '0 4px 20px rgba(78, 205, 196, 0.4)',
                    borderRadius: '50px',
                    minWidth: '160px',
                    transition: 'all 0.3s ease'
                  }}
                >
                  <svg className="me-1" width="20" height="20" fill="currentColor" viewBox="0 0 24 24">
                    <path d="M20 11H7.83l5.59-5.59L12 4l-8 8 8 8 1.41-1.41L7.83 13H20v-2z"/>
                  </svg>
                  Go Back
                </button>
                
                <button
                  onClick={handleGoLogin}
                  className="btn btn-lg px-4 py-3 fw-semibold d-flex align-items-center gap-2 border-0 custom-btn"
                  style={{
                    borderRadius: '50px',
                    color:"white",
                    background: 'linear-gradient(45deg, #4ecdc4, #44a08d)',
                    minWidth: '160px',
                    borderWidth: '2px',
                    transition: 'all 0.3s ease'
                  }}
                >
                  <i class="ri-logout-box-line"></i>
                  Logout
                </button>
              </div>
              
            </div>
          </div>
        </div>
      </div>

      <style jsx>{`
        @keyframes float {
          0%, 100% {
            transform: translateY(100vh) rotate(0deg);
            opacity: 0;
          }
          10%, 90% {
            opacity: 1;
          }
          50% {
            transform: translateY(-100vh) rotate(180deg);
          }
        }

        @keyframes rotate {
          from { transform: rotate(0deg); }
          to { transform: rotate(360deg); }
        }

        @keyframes fadeInUp {
          from {
            opacity: 0;
            transform: translateY(30px);
          }
          to {
            opacity: 1;
            transform: translateY(0);
          }
        }

        .custom-btn {
          position: relative;
          overflow: hidden;
        }

        .custom-btn::before {
          content: '';
          position: absolute;
          top: 0;
          left: -100%;
          width: 100%;
          height: 100%;
          background: linear-gradient(90deg, transparent, rgba(255, 255, 255, 0.2), transparent);
          transition: left 0.5s ease;
        }

        .custom-btn:hover {
          transform: translateY(-2px);
          box-shadow: 0 6px 25px rgba(78, 205, 196, 0.5) !important;
        }

        .custom-btn:hover::before {
          left: 100%;
        }

        .custom-btn:active {
          transform: translateY(0);
        }

        .custom-btn-outline {
          position: relative;
          overflow: hidden;
          background: rgba(255, 255, 255, 0.1);
          backdrop-filter: blur(10px);
        }

        .custom-btn-outline:hover {
          background: rgba(255, 255, 255, 0.2);
          border-color: rgba(255, 255, 255, 0.8);
          transform: translateY(-2px);
          box-shadow: 0 6px 25px rgba(255, 255, 255, 0.2);
        }

        .custom-btn-outline:active {
          transform: translateY(0);
        }

        /* Responsive adjustments */
        @media (max-width: 576px) {
          .custom-btn,
          .custom-btn-outline {
            width: 100%;
            justify-content: center;
          }
        }

        @media (max-width: 768px) {
          .display-1 {
            font-size: 6rem !important;
          }
          
          .display-4 {
            font-size: 2.5rem !important;
          }
        }
      `}</style>
    </div>
  );
};

export default NotFoundPage;